import { HorizontalLine } from "./horizontal-line";

const HorizontalSectionDivider = () => <HorizontalLine size={10} />;

export { HorizontalSectionDivider };
